import { Dates_, device, Dropdown_, Grey_, Grey_Link, PageAlwaysVisible, PageFull, PageTitle, Slider_ } from 'monica-alexandria'
import React, { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import styled, { useTheme } from 'styled-components'
import Statistics_Summary from '../../partials/statistics/Statistics_Summary'
import Statistics_Grouping_Toggle from '../../partials/statistics/Statistics_Grouping_Toggle'
import { getBreakdownView, getRetentionViewAdvanced, getStatisticsSummary } from '../../../services/api/Statistics'
import { useTranslation } from 'react-i18next'
import Statistics_Retention from '../../partials/statistics/Statistics_Retention'
import { WidgetBox } from '../../../styles/Layout.css'
import Statistics_Breakdown from '../../partials/statistics/Statistics_Breakdown'
import { scaleLinear } from 'd3-scale'
import Widget_Chart from '../../partials/widgetChart/Widget_Chart'
import { format } from 'date-fns';

const StatsSumWrapper = styled.div`
  margin-bottom: 2rem;
`

const WidgetGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  align-items: start;
  gap: 1rem;
  padding-top: 2rem;
  
  @media ${device.md}{
    
    grid-template-columns: 1fr;
  }
`

const WidgetInnerGrid = styled.div`
  display: grid;
  grid-template-rows: 1fr 2fr;

  gap: 1rem;
  
  @media ${device.md}{
    
    grid-template-columns: 1fr;
  }
`


const WidgetTitle = styled.h4`
  padding-bottom: 2rem;
`;



const WidgetChartWrapper = styled.div`
  padding-bottom: 4rem;
`
const PageTitleInner = styled.div`
  display: flex;
  align-items: center;
  gap:1rem;
`

const FiltersWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 0.5rem;
  margin-left: auto;
`;



export default function LOIS_STATISTICS() {
    const navigate = useNavigate()
    const [statisticsSum, setStatisticsSum] = useState([])
    const [groupBy, setGroupBy] = useState('subscription')
    const {t} = useTranslation();
    const {lang} = useParams();
    const themeProp = useTheme();
    
    const [average, setAverage] = useState(0);
    const [dateFilters, setDateFilters] = useState({startDate:'', endDate:''})

    const [showDatePicker, setShowDatePicker] = useState(false);
    const [renderedLabel, setRenderedLabel] = useState('');

    const [structuredData, setStructuredData] = useState([]);
    const [xLabels, setXLabels] = useState([]);
    const [rawData, setRawData] = useState({});
    const [kpiData, setKpiData] = useState({});
    
    const flatValues = structuredData.flat().map(cell => cell.sum || 0);
    const maxValue = Math.max(...flatValues, 1); // prevent division by zero

    const mainLight = getComputedStyle(document.documentElement).getPropertyValue('--mainLight').trim() || '#d6e685';
    const mainDark = getComputedStyle(document.documentElement).getPropertyValue('--mainDark').trim() || '#1e6823';
  
    const keys = Object.keys(kpiData || {});
    const lastKey = keys[keys?.length - 1];
    const lastValue = lastKey ? kpiData[lastKey] : null;
    const colorScale = scaleLinear().domain([0, maxValue]).range([mainLight, mainDark]);
    
    const months = Object.keys(kpiData || {});


    const get_statistics_lois_summary = (start, end) =>{
        getStatisticsSummary(['lois'], start, end, groupBy).then(res => {
            setStatisticsSum(res?.data?.data)

            console.log('getStatisticsSummary', res?.data?.data);
            
        });


    }
    const get_breakdown_view = (start, end) =>{
        getBreakdownView(['lois'], start, end, groupBy).then(res => {
          console.log('tsifsa!!!', res?.data?.data);
          setKpiData(res?.data?.data?.breakdown)
        });
      }
  
    const keysStats = [
        {value: "activeTotal", text:'Total active'},
        {value: "newPaid", text: "New paid"},
        {value:"returning", text: "Returning"},
        {value: "lost", text: "Lost"},
        {value: "activeQuests", text: "Active quests"},
        {value: "newActiveQuests", text: "New quests"}
      ];
    

    const transformData = (raw, key = 'sum') => {
        const yLabels = Object.keys(raw);
        const xLabelSet = new Set();

        yLabels.forEach(label => {
        Object.keys(raw[label]).forEach(month => xLabelSet.add(month));
        });

        const xLabels = Array.from(xLabelSet).sort();
        const structuredData = yLabels.map(label =>
        xLabels.map(month => raw[label][month] || { sum: 0, loyal: 0, returning: 0 })
        );


        
    return { xLabels, data: structuredData };
    };

  

    const onChangeDates = (selections) => {
      const [start, end] = selections;
    
      if (!start || !end) return;
    
      // Format for display
      const label = `${format(new Date(start), 'MMM yyyy')} → ${format(new Date(end), 'MMM yyyy')}`;
      setRenderedLabel(label);
    
      // Format for API (YYYY-MM-DD)
      const formattedStart = format(new Date(start), 'yyyy-MM-dd');
      const formattedEnd = format(new Date(end), 'yyyy-MM-dd');
    
      // Save to state
      setDateFilters({
        startDate: formattedStart,
        endDate: formattedEnd,
        renderedDates: selections,
      });
    
      // Call the API with formatted dates
      get_statistics_lois_summary(formattedStart+'T00:00:00.000Z', formattedEnd+'T00:00:00.000Z');
      get_breakdown_view(formattedStart+'T00:00:00.000Z', formattedEnd+'T00:00:00.000Z');
      setShowDatePicker(false);
    };
    const toggleDatePicker = () => {
      setShowDatePicker(prev => !prev);
    };


    useEffect(() => {
        getRetentionViewAdvanced(['lois'], groupBy)
          .then(res => {
            setRawData(res.data.data);
            const transformed = transformData(res.data.data, 'sum');
            setXLabels(transformed.xLabels);
            setStructuredData(transformed.data);

            const data = Object.values(res?.data?.data)?.flatMap(months =>
                Object.values(months).map(val => val?.sum || 0)
              );
              const avg = data.reduce((a, b) => a + b, 0) / data.length;
              setAverage(Math.round(avg));
          })
          .catch(err => console.log(err));
      }, [groupBy]);
  

    useEffect(() => {
        get_statistics_lois_summary();
        get_breakdown_view();
    }, [groupBy]);

  return (
    <PageFull>
      {showDatePicker? 
        <Slider_
          title={t("Dates")} 
          text={t("Add")}
          onClose = {()=> setShowDatePicker(false)}
          // onClick = {() =>  createFakeInvoice()}
          grey={t("Cancel")}
          iconGreyLeft="Xicon"
          onGrey= {() => setShowDatePicker(false)}
        >
          <Dates_
              allowPartialRange={true}
              onChange={onChangeDates}
              value={dateFilters?.renderedDates}
              selectRange={true}
              dateFullCellRender={(date) => date?.date()}
              maxDate={new Date()}
              minDetail="year"
              maxDetail="year"
              view="year"
            />
        </Slider_>
      :null}
        <PageAlwaysVisible>
          <PageTitle>
            <PageTitleInner>
              <Grey_Link noPadding iconLeft="Back" onClick={() => navigate(`/${lang}/akihiko/griphook/statistics`)} />
              <h1>{t('Adsnap')}</h1>
            </PageTitleInner>
            <Statistics_Grouping_Toggle groupBy={groupBy} onChange={setGroupBy} />

            <FiltersWrapper>
              <Grey_ iconLeft='Calendar' text= {renderedLabel || t("Select months")}  onClick={toggleDatePicker}/>
            </FiltersWrapper>

          </PageTitle>
            <StatsSumWrapper>
                <Statistics_Summary statistics={statisticsSum} />
            </StatsSumWrapper>
            <WidgetGrid>
                <WidgetBox>
                    <WidgetTitle>{t('Retention')}</WidgetTitle>

                    <Statistics_Retention structuredData={structuredData} xLabels={xLabels} />
                </WidgetBox>

                <WidgetInnerGrid>
                  <WidgetBox >
                    <WidgetTitle>{t('Total active')}</WidgetTitle>

                    <WidgetChartWrapper>
                        <Widget_Chart kpiData={kpiData  || []} />
                    </WidgetChartWrapper>
                </WidgetBox> 
                <WidgetBox>
                    <Statistics_Breakdown
                      keysStats={keysStats} 
                      months={months} 
                      kpiData={kpiData} 
                    /> 
                </WidgetBox >

                </WidgetInnerGrid>
            </WidgetGrid>
           
        </PageAlwaysVisible>
    </PageFull>
  )
}
